<template>
  <div id="cityTab" data-city-tab="cityTab">
    <div class="city-tab-container" :class="isFixed && 'city-tab-fixed'">
      <div class="city-tab-wrapper">
        <div class="swiper-container" ref="cityTabMain">
          <ul class="swiper-wrapper">
            <li
              v-for="item in cityList"
              :key="item.id"
              class="swiper-slide"
              :class="{ active: id === item.id, disabled: Number(item.state) === 0 }"
              @click="changeCity(item)"
              v-rseat="`click_carnival_city_${item.id}`"
            >
              {{ item.text }}
              <span v-if="item.date" class="city-tab-date">{{
                Number(item.date) > 12 ? item.date : `${item.date}月`
              }}</span>
            </li>
          </ul>
        </div>
        <div class="switch-arrow-left" ref="gtPrev" />
        <div class="switch-arrow-right" ref="gtNext" />
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'
import _ from 'lodash'

export default {
  props: {
    id: {
      type: [String, Number],
      default: '',
    },
    cityList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      swiper: null,
      isFixed: false,
    }
  },
  methods: {
    changeCity(item) {
      if (Number(item.state) === 0) {
        this.$message.warning('即将解锁 敬请期待~')
        return
      }
      this.$emit('getCityInfo', item.id)
    },
    initSwiper() {
      if (!this.swiper) {
        this.swiper = new Swiper(this.$refs.cityTabMain, {
          slidesPerView: 6,
          spaceBetween: 10,
          slidesPerGroup: 6,
          navigation: {
            nextEl: this.$refs.gtNext,
            prevEl: this.$refs.gtPrev,
          },
        })
      }
    },
    onScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      const cityId = document.getElementById('cityTab')
      if (cityId) {
        const cityTapHeight = cityId.offsetHeight
        const cityTabTop = cityId.offsetTop
        const scrollHei = cityTabTop - cityTapHeight
        // window 宽度小于 1366 页面缩放75%
        // const windowWidth = window.innerWidth
        // const top = windowWidth > 1366 ? scrollHei : scrollHei * 0.75
        if (scrollTop > scrollHei) {
          this.isFixed = true
        } else {
          this.isFixed = false
        }
      }
    },
  },
  mounted() {
    this.initSwiper()
    window.addEventListener('scroll', _.throttle(this.onScroll, 100), false)
  },
  destroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
}
</script>
<style lang="less">
#cityTab {
  height: 11.2rem;
}
.city-tab-container {
  position: relative;
  z-index: 20;
  top: -2.4rem;
  width: 100%;
  max-width: 1920px;
  height: 13rem;
  background: transparent url('../images/tab-bg.png') top center no-repeat;
  background-size: 192rem auto;

  &::before {
    display: block;
    content: '';
    position: absolute;
    top: -2.3rem;
    left: 0;
    right: 0;
    height: 2.4rem;
    background: transparent url('../images/tab-bg-top.png') top center no-repeat;
    background-size: 192rem auto;
  }
  &.city-tab-fixed {
    position: fixed;
    top: 0;
  }

  .city-tab-wrapper {
    position: relative;
    width: 108rem;
    margin: 0 auto;
  }
  .switch-arrow-left,
  .switch-arrow-right {
    top: 4rem;
    width: 1.9rem;
    height: 3rem;
  }
  .switch-arrow-left {
    left: 0;
  }
  .switch-arrow-right {
    right: 0;
  }
  .swiper-container {
    width: 101.9rem;
    max-height: 10.1rem;
    padding-top: 2.3rem;
    font-size: 0;

    ul {
      li {
        cursor: pointer;
        display: inline-block;
        width: 17.2rem;
        height: 7.5rem;
        line-height: 6rem;
        background-image: url('../images/tab-item.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        font-size: 2.4rem;
        text-align: center;
        color: #4adafe;
        font-weight: 600;
        cursor: pointer;
        .city-tab-date {
          position: absolute;
          right: -1rem;
          top: -2rem;
          display: inline-block;
          width: 6.9rem;
          height: 3.9rem;
          background-repeat: no-repeat;
          background-image: url('../images/tab-tip.png');
          background-size: 100% 100%;
          line-height: 3rem;
          font-weight: 600;
          font-size: 1.4rem;
          text-align: center;
          color: #3f8deb;
        }
        &.active {
          background-image: url('../images/tab-item-act.png');
          color: #330ad6;
          text-shadow: 0 0.2rem #fff, 0.2rem 0 #fff, -0.2rem 0 #fff, 0 -0.2rem #fff;
          .city-tab-date {
            background-image: url('../images/tab-tip-act.png');
            color: #1f037a;
            text-shadow: 0 0.2rem #fff, 0.2rem 0 #fff, -0.2rem 0 #fff, 0 -0.2rem #fff;
          }
        }
        &.disabled {
          color: #555265;
          background-image: url('../images/tab-item-dis.png');
        }
      }
    }
  }
}
</style>
